/* eslint-disable no-console */
import { handleErrors } from './ErrorActions';
import * as documentRepositoryApi from '../api/documentRepository';
import { getCurrentRepositoryId } from '../selectors/DocumentRepositorySelectors';
import { invokeBlobFileDownloading } from '../utils/commonUtils';

export const CLEAR_DOCUMENT_REPOSITORY_DETAILS = 'CLEAR_DOCUMENT_REPOSITORY_DETAILS';
export const FETCH_DOCUMENT_REPOSITORIES_SUCCESS = 'FETCH_DOCUMENT_REPOSITORIES_SUCCESS';
export const FETCH_DOCUMENT_REPOSITORY_DETAILS_SUCCESS =
  'FETCH_DOCUMENT_REPOSITORY_DETAILS_SUCCESS';
export const FETCH_SELECTED_DOCUMENTS = 'FETCH_SELECTED_DOCUMENTS';
export const FETCH_SELECTED_DOCUMENTS_SUCCESS = 'FETCH_SELECTED_DOCUMENTS_SUCCESS';
export const FETCH_SELECTED_DOCUMENTS_FAILED = 'FETCH_SELECTED_DOCUMENTS_FAILED';
export const CHANGE_PERSONAL_DEFAULT = 'CHANGE_PERSONAL_DEFAULT';
export const CHANGE_PERSONAL_DEFAULT_SUCCESS = 'CHANGE_PERSONAL_DEFAULT_SUCCESS';
export const CHANGE_PERSONAL_DEFAULT_FAILED = 'CHANGE_PERSONAL_DEFAULT_FAILED';
export const CLEAR_DOCUMENT_REPOSITORY_STORE = 'CLEAR_DOCUMENT_REPOSITORY_STORE';

export const clearDocumentRepositoryDetails = () => ({
  type: CLEAR_DOCUMENT_REPOSITORY_DETAILS,
});

export const fetchDocumentRepositoriesSuccess = (data) => ({
  type: FETCH_DOCUMENT_REPOSITORIES_SUCCESS,
  payload: data,
});

export const fetchDocumentRepositoryDetailsSuccess = (data) => ({
  type: FETCH_DOCUMENT_REPOSITORY_DETAILS_SUCCESS,
  payload: { data },
});

export const changePersonalDefaultSuccess = (data) => ({
  type: CHANGE_PERSONAL_DEFAULT_SUCCESS,
  payload: { data },
});

export const clearDocumentRepositoryStore = () => ({
  type: CLEAR_DOCUMENT_REPOSITORY_STORE,
});

export const fetchDocumentRepositories = () => async (dispatch) => {
  try {
    const apiData = await documentRepositoryApi.getDocumentRepositories();

    if (apiData.hasError || apiData.DisplayMessage) {
      dispatch(handleErrors(apiData.errors, { defaultMessage: apiData.DisplayMessage }));
    }

    dispatch(
      fetchDocumentRepositoriesSuccess({
        repositories: apiData.Repositories,
        isDefaultSetForUser: apiData.IsDefaultSetForUser,
        defaultRepository: apiData.DefaultRepository,
      })
    );
  } catch (error) {
    console.log(`fetchDocumentRepositories() failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
  }
};

export const fetchDocumentRepositoryDetails = (params) => async (dispatch) => {
  try {
    const apiData = await documentRepositoryApi.getDocumentRepositoryDetails(params);

    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      return;
    }

    dispatch(fetchDocumentRepositoryDetailsSuccess(apiData.RepositoryDetails.Content));
  } catch (error) {
    console.log(`fetchDocumentRepositoryDetails() failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
  }
};

export const fetchSelectedDocuments = (selectedDocuments) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_SELECTED_DOCUMENTS });

    const documentsIds = selectedDocuments.map((doc) => doc.ItmId);
    const { data, headers } = await documentRepositoryApi.downloadSelectedDocuments(documentsIds);
    const contentType = headers['content-type'];
    const contentDisposition = headers['content-disposition'];

    if (data.hasError) {
      dispatch({ type: FETCH_SELECTED_DOCUMENTS_FAILED });
      dispatch(handleErrors(data.errors));
      return;
    }

    // if content-type is json, it's an error response
    if (contentType === 'application/json') {
      const reader = new FileReader();

      reader.addEventListener('loadend', () => {
        const { errors = [] } = JSON.parse(reader.result);
        dispatch({ type: FETCH_SELECTED_DOCUMENTS_FAILED });
        dispatch(handleErrors(errors));
      });

      reader.readAsText(data);

      return;
    }

    dispatch({ type: FETCH_SELECTED_DOCUMENTS_SUCCESS });

    let fileName = '';

    if (contentDisposition) {
      [, fileName] = contentDisposition.match(/filename=(.+)/);
    }

    invokeBlobFileDownloading(data, fileName);
  } catch (error) {
    console.log(`fetchSelectedDocuments() failed: ${JSON.stringify(error)}`);

    dispatch({ type: FETCH_SELECTED_DOCUMENTS_FAILED });
    dispatch(handleErrors(error));
  }
};

export const changePersonalDefaultRepository = ({ repositoryName, isDelete }) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: CHANGE_PERSONAL_DEFAULT });

    const id = getCurrentRepositoryId(getState(), { repositoryName });

    let apiData;

    if (isDelete) {
      apiData = await documentRepositoryApi.removePersonalDefaultRepository(id);
    } else {
      apiData = await documentRepositoryApi.setPersonalDefaultRepository(id);
    }

    if (apiData.hasError) {
      dispatch({ type: CHANGE_PERSONAL_DEFAULT_FAILED });
      dispatch(handleErrors(apiData.errors));
      return;
    }

    dispatch(changePersonalDefaultSuccess(apiData.DefaultRepository));
  } catch (error) {
    console.log(`changePersonalDefaultRepository() failed: ${JSON.stringify(error)}`);

    dispatch({ type: CHANGE_PERSONAL_DEFAULT_SUCCESS });
    dispatch(handleErrors(error));
  }
};
